module.exports = __webpack_public_path__ + "img/Ntabi.2397e5f3.png";